import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";
import { post_job_feed_api, update_job_api } from "../../DAL/partner/partners";
import TextEditor from "../editors/ReactEditor";
import { useIds } from "../../hook/AdminContext";

const textFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: "50px",
    color: "black",
  },
};
const descriptionStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: "140px",
    color: "black",
  },
};

export default function PostJobModal({
  open,
  handleClose,
  refreshlist,
  loadMorePath,
  searchTerm,
  loadingstate,
  id,
  jobData,
  editMode,
  sourceId,
  selectedFilter,
  filter,
}) {
  console.log(id, "idididididididididididid");
  const pages = [
    "Hospitality",
    "Warehouse",
    "Healthcare",
    "Retail Source",
    "Office Source",
    "Food Source",
    "Construction Source",
    "FitOut Source",
  ];
  console.log(sourceId, "ididididididididid");
  const [inputs, setInputs] = React.useState({
    detailed_description: "",
  });
  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");
  const location = useLocation();
  const [jobType, setJobType] = useState("");
  const [chooseTime, setChooseTime] = useState("");
  const [page, setPage] = useState("Hospitality");
  const [experienceLevel, setExperienceLevel] = useState("");
  const { userInfo, isRefresh, setIsRefresh } = useIds();

  const [salary, setSalary] = useState("");
  const [description, setDescription] = useState("");
  const [minSalary, setMinSalary] = useState("");
  const [salaryType, setSalaryType] = useState("fixed");

  const [maxSalary, setMaxSalary] = useState("");
  const [salaryFrequency, setSalaryFrequency] = useState("");
  const [groups, setGroups] = React.useState([]);
  const [detailDescriptionCk, setDetailDescriptionCk] = React.useState("");
  const [loading, setLoafing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status, setstatus] = useState(true);
  const [fixedSalary, setFixedSalary] = useState("");

  const navigate = useNavigate();
  console.log(jobData, "jobDatajobDatajobDatajobData");

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isSmallScreen ? "95%" : "90%", // Reduce width for mobile screens
    maxWidth: isSmallScreen ? "400px" : "750px", // Limit max width for better mobile display
    maxHeight: isSmallScreen ? "70vh" : "90vh", // Reduce height on small screens

    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    padding: isSmallScreen ? "15px" : "20px", // Adjust padding
    outline: "none",
    paddingTop: "0px",
    paddingBottom: "13px !important",
    overflowY: isSmallScreen ? "auto" : "auto", // Enable scrolling if content overflows
  };
  // let id = localStorage.getItem("source_id");
  // console.log(id, "ididididid");
  const jobId = id || localStorage.getItem("source_id");
  console.log(jobId, "jobIdjobIdjobIdjobId");

  useEffect(() => {
    if (editMode && jobData) {
      setInputs({
        detailed_description: jobData.description,
      });
      setTitle(jobData.jobTitle || "");
      setAddress(jobData.location || "");
      setJobType(jobData.jobType || "");
      setChooseTime(jobData.educationRequired || "");
      setExperienceLevel(jobData.experienceRequired || "");
      setSalaryType(jobData.salaryType);

      setMinSalary(jobData.minSalary || "");
      setMaxSalary(jobData.maxSalary || "");
      setSalaryFrequency(jobData.frequencySalary || "");
      setDescription(jobData.description || "");
      setstatus(jobData?.status);
      if (jobData.salaryType === "fixed") {
        setFixedSalary(jobData.salary || "");
      } else {
        setMinSalary(jobData.minSalary || "");
        setMaxSalary(jobData.maxSalary || "");
      }
    } else if (!editMode) {
      // Reset fields when posting a new job
      setInputs({ detailed_description: "" });
      setTitle("");
      setAddress("");
      setJobType("");
      setChooseTime("");
      setExperienceLevel("");
      setSalaryType("fixed");
      setFixedSalary("");
      setMinSalary("");
      setMaxSalary("");
      setSalaryFrequency("");
      setPage("");
      setstatus(true);
      setInputs({
        detailed_description: "",
      });
    }
  }, [editMode, jobData, open]);
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputs.detailed_description) {
      enqueueSnackbar("Description is required", { variant: "error" });
      return;
    }
    setSubmitting(true);
    let job;
    if (selectedFilter) {
      job = selectedFilter;
    } else {
      job = jobId;
    }
    const formData = {
      jobTitle: title,
      location: address,
      jobType: jobType,
      educationRequired: chooseTime,
      experienceRequired: experienceLevel,
      salaryType: salaryType,
      frequencySalary: salaryFrequency,
      description: inputs.detailed_description,
      created_for: selectedFilter || id,
      status: status,
    };

    // Add salary fields based on type
    if (salaryType === "fixed") {
      formData.salary = fixedSalary;
    } else {
      formData.minSalary = minSalary;
      formData.maxSalary = maxSalary;
    }

    let result;

    if (editMode && jobData?._id) {
      result = await update_job_api(jobData._id, formData);
      setIsRefresh(!isRefresh);
    } else {
      result = await post_job_feed_api(formData);
    }

    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      handleClose();
      const idToSend = location.pathname === "/home" ? undefined : id; // Check if it's home
      let obj = "";
      if (id) {
        obj = id;
      } else {
        obj = selectedFilter;
      }

      refreshlist(loadMorePath, searchTerm, loadingstate, id || selectedFilter);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }

    setSubmitting(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div
          className="p-1 mt-2 post-job-check"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 style={{ fontSize: "17px", fontWeight: "bold" }}>
            {editMode ? "Update Job" : "Post Job"}
          </h4>
          <IconButton onClick={handleClose}>
            <Close style={{ fontSize: "23px" }} />
          </IconButton>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          {/* Job Title and Location */}
          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
            }}
          >
            <TextField
              required
              sx={textFieldStyle}
              label="Job Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              required
              sx={textFieldStyle}
              label="Location"
              fullWidth
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          {/* Job Type and Education */}
          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
            }}
          >
            <FormControl required fullWidth sx={textFieldStyle}>
              <InputLabel>Job Type</InputLabel>
              <Select
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
                label="Job Type"
              >
                <MenuItem value="Contract">Contract</MenuItem>
                <MenuItem value="Temporary">Temporary</MenuItem>
                <MenuItem value="Permanent">Permanent</MenuItem>
                <MenuItem value="Remote">Remote</MenuItem>
                <MenuItem value="Hybrid">Hybrid</MenuItem>
              </Select>
            </FormControl>

            <FormControl required fullWidth sx={textFieldStyle}>
              <InputLabel>Education Required</InputLabel>
              <Select
                value={chooseTime}
                onChange={(e) => setChooseTime(e.target.value)}
                label="Education Required"
              >
                <MenuItem value="no_minimum_required">
                  No Minimum Required
                </MenuItem>
                <MenuItem value="third_level_certificate">
                  Third level Certificate
                </MenuItem>
                <MenuItem value="junior_certificate">
                  Junior Certificate
                </MenuItem>
                <MenuItem value="leaving_certificate">
                  Leaving Certificate
                </MenuItem>
                <MenuItem value="third_level_diploma">
                  Third Level Diploma
                </MenuItem>
                <MenuItem value="third_level_degree">
                  Third Level Degree
                </MenuItem>
                <MenuItem value="phd">PHD</MenuItem>
                <MenuItem value="masters">Masters</MenuItem>
                <MenuItem value="post_graduate_qualification">
                  Post Graduate Qualification
                </MenuItem>
                <MenuItem value="professional_qualification">
                  Professional Qualification
                </MenuItem>
                <MenuItem value="part_professional_qualification">
                  Part Professional Qualification
                </MenuItem>
                <MenuItem value="trade_qualification">
                  Trade Qualification
                </MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Experience and Salary Type */}
          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
            }}
          >
            <FormControl required fullWidth sx={textFieldStyle}>
              <InputLabel>Experience Required</InputLabel>
              <Select
                value={experienceLevel}
                onChange={(e) => setExperienceLevel(e.target.value)}
                label="Experience Required"
              >
                <MenuItem value="1year">1 Year</MenuItem>
                <MenuItem value="1to3year">1-3 Years</MenuItem>
                <MenuItem value="3to5year">3-5 Years</MenuItem>
                <MenuItem value="5to7year">5-7 Years</MenuItem>
                <MenuItem value="7to10year">7-10 Years</MenuItem>
                <MenuItem value="10plusyears">10+ Years</MenuItem>
              </Select>
            </FormControl>

            <FormControl required fullWidth sx={textFieldStyle}>
              <InputLabel>Salary Type</InputLabel>
              <Select
                value={salaryType}
                onChange={(e) => setSalaryType(e.target.value)}
                label="Salary Type"
              >
                <MenuItem value="fixed">Fixed</MenuItem>
                <MenuItem value="range">Range</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Salary Fields (Conditional) */}
          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
            }}
          >
            {salaryType === "fixed" ? (
              <TextField
                required
                sx={textFieldStyle}
                label="Salary"
                fullWidth
                type="number"
                value={fixedSalary}
                onChange={(e) => setFixedSalary(e.target.value)}
              />
            ) : (
              <>
                <TextField
                  required
                  sx={textFieldStyle}
                  label="Min Salary"
                  fullWidth
                  type="number"
                  value={minSalary}
                  onChange={(e) => setMinSalary(e.target.value)}
                />
                <TextField
                  required
                  sx={textFieldStyle}
                  label="Max Salary"
                  fullWidth
                  type="number"
                  value={maxSalary}
                  onChange={(e) => setMaxSalary(e.target.value)}
                />
              </>
            )}
            <FormControl fullWidth sx={textFieldStyle} required>
              <InputLabel>Frequency</InputLabel>
              <Select
                value={salaryFrequency}
                onChange={(e) => setSalaryFrequency(e.target.value)}
                label="Frequency"
              >
                <MenuItem value="Hourly">Hourly</MenuItem>
                <MenuItem value="Daily">Daily</MenuItem>
                <MenuItem value="Weekly">Weekly</MenuItem>
                <MenuItem value="Monthly">Monthly</MenuItem>
                <MenuItem value="Yearly">Yearly</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Source and Status */}
          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
            }}
          >
            {location.pathname === "/home" ? (
              <div
                style={{ display: "flex", flexDirection: "row", gap: "10px" }}
              >
                <FormControl required fullWidth sx={textFieldStyle}>
                  <InputLabel>Add Page to</InputLabel>
                  <Select
                    value={page}
                    onChange={(e) => setPage(e.target.value)}
                    label="Add Page to"
                  >
                    {pages?.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl required fullWidth sx={textFieldStyle}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={status}
                    onChange={(e) => setstatus(e.target.value)}
                    label="Status"
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </div>
            ) : (
              <div className="col-md-6">
                <FormControl required fullWidth sx={textFieldStyle}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={status}
                    onChange={(e) => setstatus(e.target.value)}
                    label="Status"
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </div>
            )}
          </div>

          {/* Description */}
          <h4
            style={{
              fontSize: "17px",
              fontWeight: "bold",
              marginTop: "8px",
              marginBottom: "0px",
            }}
          >
            Description*
          </h4>
          <TextEditor
            required
            inputs={inputs}
            setInputs={setInputs}
            name="detailed_description"
          />

          {/* Submit Button */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={submitting}
            style={{
              backgroundColor: "#000080",
              color: "white",
              marginTop: "16px",
              height: "50px",
              borderRadius: "8px",
            }}
          >
            {editMode
              ? submitting
                ? "Updating..."
                : "Update"
              : submitting
              ? "Posting..."
              : "Post Job"}
          </Button>
        </form>
      </Box>
    </Modal>
  );
}
